import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import Paper from "@mui/material/Paper";

import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { Breadcrumbs } from "components/Breadcrumbs";

import { AppTitleContext } from "app_context";
import { useRouteMatch } from "react-router";
import { useLoadCounter } from "hooks/useLoadCounter";

export const MachinesPage = () => {
  const match = useRouteMatch();
  const appTitleContext = useContext(AppTitleContext);

  const machineId = match.params.id;
  const { loading, error, response } = useFetchGetV2(`machines/${machineId}`);
  const tableLoadCount = useLoadCounter(loading);

  useEffect(() => {
    appTitleContext.setPageTitle(
      <Breadcrumbs>
        <Link to={`/pages/settings`}>Settings</Link>
        {response && <span>Machine: {response?.name}</span>}
      </Breadcrumbs>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  if (loading || error || !response) {
    return <></>;
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell data-col={1}>Property</TableCell>
              <TableCell data-col={2}>Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            data-qa_loading={loading}
            data-qa_load_count={tableLoadCount}
          >
            <TableRow>
              <TableCell data-col={1}>ID</TableCell>
              <TableCell data-col={2}>{response?.id}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Name</TableCell>
              <TableCell data-col={2}>{response?.name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Reference</TableCell>
              <TableCell data-col={2}>{response?.reference}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Latitude</TableCell>
              <TableCell data-col={2}>{response?.latitude}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Longitude</TableCell>
              <TableCell data-col={2}>{response?.longitude}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Model</TableCell>
              <TableCell data-col={2}>{response?.model}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell data-col={1}>Scalar Configurations</TableCell>
              <TableCell data-col={2}>
                {response?.scalar_configurations?.map(configId => {
                  return (
                    <p>
                      <Link
                        to={`/pages/settings/scalar_configuration/${configId}`}
                      >
                        {configId}
                      </Link>
                    </p>
                  );
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Site</TableCell>
              <TableCell data-col={2}>
                <Link to={`/pages/settings/site/${response?.site}`}>
                  {response?.site_name}
                </Link>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell data-col={1}>Create Date</TableCell>
              <TableCell data-col={2}>{response?.create_date}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Create User</TableCell>
              <TableCell data-col={2}>
                <Link to={`/pages/settings/user/${response?.create_user}`}>
                  {response?.create_user}
                </Link>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Change Date</TableCell>
              <TableCell data-col={2}>{response?.change_date}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell data-col={1}>Change Date</TableCell>
              <TableCell data-col={2}>
                <Link to={`/pages/settings/user/${response?.change_user}`}>
                  {response?.change_user}
                </Link>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
